(function(window, $, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Affiliate = window.JVZoo.Affiliate || {};
    window.JVZoo.Affiliate.AffiliateBonus = window.JVZoo.Affiliate.AffiliateBonus || {};

    var _showSpeed = 1000;
    var _hideSpeed = _showSpeed/2;

    /**
     * Fades an HTML element into view
     * @param element
     * @returns {boolean}
     * @constructor
     */
    window.JVZoo.Affiliate.AffiliateBonus.Show = function (element) {
        var $element = element instanceof $ ? element : $(element);
        if ($element.length < 1) {
            return false;
        }
        $element.each(function (index, target) {
            $(target).fadeIn(_showSpeed);
        });
        return true;
    };

    /**
     * Fades an HTML element out of view
     * @param element The element to be removed
     * @param {boolean} remove If true, the element is removed after it fades from view
     * @param {number} speed If specified, overrides the default speed at which items are removed.
     * @return {boolean} True when successful, otherwise false
     * @constructor
     */
    window.JVZoo.Affiliate.AffiliateBonus.Hide = function (element, remove, speed) {
        remove = typeof remove === "boolean" ? remove : false;
        speed = typeof speed === "number" ? speed : _hideSpeed;
        var $element = element instanceof $ ? element : $(element);
        if ($element.length < 1) {
            return false;
        }
        if ($element.length === 1) {
            if (remove) {
                $element.fadeOut(speed, function () {
                    $(this).remove();
                });
                return true;
            }
            if ($element.is(':visible')) {
                $element.fadeOut(speed);
            }
            return true;
        }
        $element.each(function (index, target) {
            if (remove) {
                $(target).fadeOut(speed, function () {
                    $(this).remove();
                });
                return;
            }
            if ($element.is(':visible')) {
                $(target).fadeOut(speed);
            }
        });
        return true;
    };


    /**
     * Closes the modal without submitting the form
     * @param event
     */
    var onClickCloseModal = function(event){
        event.preventDefault();
        window.JVZoo.Affiliate.AffiliateBonus.Hide($("#affiliate-bonus-modal"));
    };

    /**
     * Opens the modal without submitting the form
     * @param event
     */
    var onClickOpenModal = function(event){
        event.preventDefault();
        window.JVZoo.Affiliate.AffiliateBonus.Show($("#affiliate-bonus-modal"));
    };

    window.JVZoo.Affiliate.AffiliateBonus.applyBindings = function (root) {
        var $rootElement = root instanceof $ ? root : $(root);
        $rootElement.on('click', '[id=showAffiliateBonus]', onClickOpenModal);
        $rootElement.on('click', '[id=closeModal]', onClickCloseModal);
    };

    $(document).ready(function () {
        window.JVZoo.Affiliate.AffiliateBonus.applyBindings(document);

        window.JVZoo.Controls.NewControlEvent.subscribe(
            this,
            function(args) {
                applyBindings(window.JVZoo.Common.AsjQueryObject(args.targetElement));
            },
            {}
        );
    });

})(window, jQuery);